import { createAxiosConfig, creditAxiosApi } from "services/axiosApi";
import { ShareRecordRequestType, ShareResourceDisplayType } from "./types/share";

export async function postShareRecordsByResourceId(resource: ShareResourceDisplayType, resourceId: string, body: ShareRecordRequestType, token: string) {
    const endpoint = `/${resource}/${resourceId}/Share`;
    const axiosConfig = createAxiosConfig(token);
    return await creditAxiosApi.post(endpoint, body, axiosConfig);
}
